import React from 'react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import ReadCookie from '../../../functions/readcookies';
import View from './view';
import Add from './add';
import Titles from '../../title';

class Title extends React.Component {

  state = {
    data: [], menuPermission: {}
  }

  componentDidMount() {
    this.getCombos();
  }

  getCombos() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    context.setState({
      load: true,
      message: 'Getting Combo Details',
      adddialog: false
    })
    $.ajax({
      type: 'POST',
      data: { 'userId': userId },
      url: Server() + 'combo/get.php',
      success: function(data)
      {
        context.setState({ load: false });
        try {
          data = JSON.parse(data);
          context.setState({ data: data });
        } catch (e) {
          console.log(e);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  render() {
    let i = 1;
    let view = this.state.data.map((x) => {
      i++;
      return (
        <View  menuPermission={this.state.menuPermission} item={x} sino={i} getCombos={this.getCombos.bind(this)} />
      )
    })
    return (
      <div>
        { this.props.from == 'router' ?
          <Titles title={'Combo'} /> : null
        }
        <div style={{padding: '2%'}}>
          
          <Add getCombos={this.getCombos.bind(this)} />
          
          <table width="100%" id="table">
            <tr>
              <th id="tableheader"><center>Sino</center></th>
              <th id="tableheader"><center>Combo Name</center></th>
              <th id="tableheader"><center>Image</center></th>
              <th id="tableheader"><center>Status</center></th>
              <th id="tableheader"><center>Priority</center></th>
              <th id="tableheader"><center>View</center></th>
              <th id="tableheader"><center>Delete</center></th>
            </tr>
            {view}
          </table>
        </div>
      </div>
    );
  }
}

export default Title;
